import { render } from "./PlayMusic.vue?vue&type=template&id=39ba59ac&scoped=true"
import script from "./PlayMusic.vue?vue&type=script&lang=js"
export * from "./PlayMusic.vue?vue&type=script&lang=js"

import "./PlayMusic.vue?vue&type=style&index=0&id=39ba59ac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-39ba59ac"

export default script